<!--
 * @Author: your name
 * @Date: 2021-07-05 10:40:24
 * @LastEditTime: 2021-07-14 10:14:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \platform_tenant\src\layout\components\Sidebar\index.vue
-->
<template>
  <div :class="{ 'has-logo': showLogo }" class="container-menu">
    <div class="container-menu-real">
      <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
      <div class="main-menu-container">
        <div class="logo-container">
          <img class="logo-icon" src="../../../assets/image/login-icon.png" alt="">
        </div>
        <!-- 主菜单 -->
        <el-scrollbar id="main-menu" wrap-class="scrollbar-wrapper">
          <el-menu
            :default-active="activeMenuMain"
            :collapse="false"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :unique-opened="true"
            :active-text-color="variables.menuActiveText"
            :collapse-transition="false"
            mode="vertical"
          >
            <sidebar-item
              v-for="(route,index) in permission_routes"
              :key="(index + 1)"
              :is-show-sub-menu="false"
              :item="route"
              :base-path="route.path"
              @main-menu-click="mainMenuClick"
            />
          </el-menu>
        </el-scrollbar>
        <div class="infomenu">
          <!--          <Message />-->
          <UserCenter />
        </div>
      </div>
      <!-- 子菜单 -->
      <div v-show="!isHomePage" class="submenucontainer">
        <div class="submenutitle">{{ subMenuTitle }}</div>
        <el-scrollbar class="detail-menu" wrap-class="scrollbar-wrapper">
          <el-menu
            ref="subMenu"
            :default-active="activeMenu"
            :collapse="false"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :unique-opened="false"
            :active-text-color="variables.menuActiveText"
            :collapse-transition="false"
            :default-openeds="menuListRight.map(item=>item.path)"
            mode="vertical"
          >
            <sidebar-item
              v-for="(route) in menuListRight"
              :key="menuRihtBasePath + '/' + route.path"
              :item="route"
              :base-path=" '/' + route.path"
            />
          </el-menu>
        </el-scrollbar>
      </div>
    </div>
    <div class="container-menu-shadow">
      <div class="main-menu-container" />
      <div v-show="!isHomePage" class="submenucontainer" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Logo from './Logo'
import SidebarItem from './SidebarItem'
// import Message from './Message.vue'
import UserCenter from './UserCenter.vue'
import variables from '../../../styles/variables.scss'

export default {
  name: 'Sidebar',
  components: {
    SidebarItem,
    // Message,
    UserCenter
  },
  data() {
    return {
      menuListRight: [],
      menuRihtBasePath: '',
      activeRoute: null,
      subMenuPath: ''
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar',
      'avatar',
      'device'
    ]),
    activeMenu() {
      const route = this.$route
      console.log('route', route)
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    activeMenuMain() {
      const target = this.activeMenu.match(/(^\/\w+)\/?/)
      if (target) return target[1]
      return ''
    },
    subMenuTitle() {
      console.log('subMenuTitle')
      console.log('this.activeRoute', this.activeRoute)
      if (this.activeRoute) {
        if (this.activeRoute.menu_name) {
          return this.activeRoute.menu_name
        }
        if (this.activeRoute.children && this.activeRoute.children.length === 1) {
          return this.activeRoute.children[0].name || this.activeRoute.children[0].menu_name
        }
      }
      return ''
    },
    setting: {
      get() {
        return this.$store.state.settings.showSettings
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    },
    isHomePage() {
      return this.menuRihtBasePath === '/'
    }
  },
  watch: {
    $route(route) {
      this.setSubMenu(route)
    },
    menuListRight() {
      // this.$nextTick(() => {
      //   this.menuListRight.forEach(item => {
      //     this.$refs.subMenu.open(item.path)
      //   })
      // })
    }
  },
  mounted() {
    this.setSubMenu(this.$route)
  },
  methods: {
    /** 非首页时，需要设置子菜单 */
    setSubMenu(route) {
      // if (this.isHomePage) return
      const regList = route.path.match(/^\/(\w+)\/?/)
      console.log('regList:', regList)
      let targetRoute = null
      if (regList) {
        const path = regList[1]
        console.log('path:', path)
        if (path === 'dashboard') {
          targetRoute = this.permission_routes.find(item => item.redirect === '/dashboard')
        } else {
          console.log('this.permission_routes:', this.permission_routes)
          targetRoute = this.permission_routes.find(item => item.path === `/${path}`)
        }

        console.log('targetRoute:', targetRoute)
        this.activeRoute = targetRoute
        this.menuListRight = targetRoute.children
        this.menuRihtBasePath = targetRoute.path
      }
      // this.$refs.subMenu.open()
    },
    /** 打开第一个子菜单 */
    openFirstSubMenu() {
      if (this.isHomePage) return
      this.subMenuPath = this.menuRihtBasePath
      this.getFirstSubMenuPath(this.menuListRight[0])
      console.log('最终要跳转的地址', this.subMenuPath)
      this.$router.push(this.subMenuPath)
    },
    /** 获取第一个子菜单路径 */
    getFirstSubMenuPath(menu) {
      console.log('获取第一个子菜单路径', menu)
      this.subMenuPath = `${menu.path}`
      if (menu.children) {
        this.getFirstSubMenuPath(menu.children[0])
      }
    },
    /** 主菜单点击 */
    mainMenuClick(item) {
      if (item.menu_name === '收银台') {
        const a = window.screen.width + 'px'
        const b = window.screen.height + 'px'
        // window.open(this.$router.resolve({ path: '/cash' }).href, '_blank', 'width=800,height=800')
        window.open(this.$router.resolve({ path: '/cash' }).href, '_blank', `width=${a},height=${b}`)
        return true
      }
      if (this.activeRoute === item) return
      console.log('主菜单点击', item)
      this.menuListRight = []
      this.menuRihtBasePath = '/'
      if (item.children) {
        this.activeRoute = item
        this.menuListRight = item.children
        this.menuRihtBasePath = item.path
      } else {
        this.activeRoute = item
      }
      this.openFirstSubMenu()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.container-menu {
  display: flex;

  .container-menu-real {
    position: fixed;
    z-index: 999;
  }

  .container-menu-real,
  .container-menu-shadow {
    height: 100%;
    display: flex;

    .main-menu-container {
      background: $mainMenuBackground;
      width: 90px;
      position: relative;

      .logo-container {
        font-size: 18px;
        color: white;
        width: 90px;
        height: 90px;
        background-color: $mainMenuBackground;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .logo-icon {
          width: 45px;
        }
      }

      #main-menu {
        background: $mainMenuBackground;
      }

      .infomenu {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100px;
        background: $mainMenuBackground;
        position: relative;
      }
    }

    .submenucontainer {
      margin-top: 39px;
      width: 200px;
      flex: 1;
      background-color: white;
      // box-shadow: 0 0 15px #cbcbcb;
      overflow: hidden;

      .submenutitle {
        width: 100%;
        height: 80px;
        font-size: 26px;
        color: #333;
        font-weight: bold;
        line-height: 80px;
        padding-left: 30px;
        margin-top: 30px;
      }
    }
  }

}

#app .sidebar-container ::v-deep {

  .el-menu-item,
  .el-submenu__title {
    font-size: 16px;
  }

  #main-menu {
    flex-shrink: 0;

    .el-menu,
    .el-submenu__title,
    .el-menu-item {
      color: white !important;
      background: $mainMenuBackground !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .el-menu-item {
      color: white !important;
      background: $mainMenuBackground !important;
      padding: 10px !important;
      margin: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      width: 70px;
      border-radius: 10px;

      span {
        height: 20px;
        line-height: 20px;
      }

      .svg-icon {
        width: 25px;
        height: 25px;
        margin-right: 0;
      }

      &.is-active {
        background: $mainMenuActiveBg !important;
      }
    }

    .el-submenu__title:hover,
    .submenu-title-noDropdown:hover {
      background: #00000033 !important;

      &.is-active {
        background: $mainMenuActiveBg !important;
      }
    }
  }

  .scrollbar-wrapper {
    &::-webkit-scrollbar {
      width: 0px;
    }
  }

  .detail-menu {
    .el-menu-item {
      padding: 0 0 0 30px;
      text-align: left;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
    }
    .el-submenu.is-disabled .el-submenu__title, .el-submenu.is-disabled .el-menu-item {
      opacity: 1;
    }
  }
}
</style>
